import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";

interface HelpStateProps {
	onRetry: () => void;
	retrying?: boolean;
	message?: string;
}

/**
 * A failed read, said plainly, with a way to try again. In the theme's own
 * colours: `QueryRetry` uses a fixed grey that's hard to read on dark themes.
 */
function HelpState({
	onRetry,
	retrying = false,
	message = "We couldn't load this part of the Help Centre.",
}: Readonly<HelpStateProps>) {
	return (
		<div className="help-state" role="alert">
			<p className="help-state__text">
				{message} Check your connection and try again.
			</p>
			<Button
				icon={<ReloadOutlined aria-hidden="true" />}
				loading={retrying}
				onClick={onRetry}
			>
				Try again
			</Button>
		</div>
	);
}

export default HelpState;
